const DEFAULT_MAX_PHONE_NUMBER_LENGTH = 14;

export const bytesToMegaBytes = (bytes: number, roundTo: number) =>
  roundTo ? (bytes / (1024 * 1024)).toFixed(roundTo) : bytes / (1024 * 1024);

export const getFormattedAmount = (val: number) =>
  val.toLocaleString("en-US", { minimumFractionDigits: 2 });

export const stringToNumberUtil = (
  value: string,
  callback?: (trimmed: string) => string
): string => {
  if (value.length) {
    const trimmed = value.replace(/[^0-9]|\s/g, "");
    return callback ? callback(trimmed) : trimmed;
  }

  return "";
};

export const formatPhoneNumberUtil = (
  value: string,
  maxLength = DEFAULT_MAX_PHONE_NUMBER_LENGTH
): string => {
  return stringToNumberUtil(value, (formatted) => {
    if (formatted.length) {
      return (
        formatted
          .substring(0, maxLength)
          .match(/.{1,4}/g)
          ?.join(" ") || ""
      );
    }

    return "";
  });
};

export const formatTaxIdNumberUtil = (value: string): string => {
  return stringToNumberUtil(value, (formatted) => {
    return formatted.match(/.{1,4}/g)?.join(" ") || "";
  });
};

export const fileToDataUrl = async (
  file: File,
  asPureBase64 = false
): Promise<string | ArrayBuffer | null> => {
  if (!file) return "";
  return await new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = () =>
      resolve(
        asPureBase64
          ? (fileReader.result as string).split(",")[1]
          : fileReader.result
      );
    fileReader.readAsDataURL(file);
  });
};

export const uploadedIdPhotoAllowedTypesArray = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "application/pdf",
];

export const uploadedIdPhotoAllowedTypes = () =>
  uploadedIdPhotoAllowedTypesArray.join(",");

export const convertBase64ImageToFile = function (
  image: string,
  type = "image/jpeg"
) {
  if (!image || typeof image !== "string") return null;
  const byteString = atob(image.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  const newBlob = new Blob([ab], {
    type,
  });
  return newBlob;
};

export const getKeysFrom2DArray = (arr: string[][]): string[] =>
  arr.map((i) => i[0]);

export const handleRequestBySr = <T>(promise: Promise<T>) =>
  promise.then((data) => [undefined, data]).catch((err) => [err, undefined]);

export const toTitleCase = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const removePlusSign = (phoneNumber: string): string => {
  return phoneNumber.startsWith("+") ? phoneNumber.substring(1) : phoneNumber;
};

export const addCountryCodeSymbol = (countryCode: string) => {
  return countryCode.replace(/^(\+)?/, "+");
};

export const parsePhoneNumber = (
  phoneNumber: string,
  code: string | null = null
) => {
  // Remove any non-numeric characters from the phone number
  const numericPhoneNumber = phoneNumber.replace(/\D/g, "");

  // Extract the country code and phone number
  let countryCode = numericPhoneNumber.substring(0, 2); // Assuming the country code is two digits
  let phoneNumberWithoutCode = numericPhoneNumber.substring(2);
  if (!!code && countryCode !== code) {
    countryCode = code;
    phoneNumberWithoutCode = numericPhoneNumber;
  }

  // Return an array containing the country code and phone number
  return {
    countryCode: addCountryCodeSymbol(countryCode),
    phoneNumber: phoneNumberWithoutCode,
  };
};
